import React from 'react'
import { Box, CircularProgress, Alert, Typography } from '@mui/material'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'

const OrangeOpaskaDailyChart = ({ data, loading, error }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) return <Alert severity="error">{error}</Alert>
  if (!data) return null

  const chartData = (data.day_by_day || []).map(d => ({
    ...d,
    label: d.date.slice(5), // MM-DD
  }))

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>Sprzedaż dzienna - Opaska SOS</Typography>
      {chartData.length === 0 ? (
        <Alert severity="info">Brak danych sprzedaży dla wybranego okresu</Alert>
      ) : (
        <Box sx={{ height: 400 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="label" fontSize={11} />
              <YAxis />
              <Tooltip
                formatter={(value) => [value, 'Sprzedaż']}
                labelFormatter={(label) => `Dzień: ${label}`}
              />
              <Bar dataKey="sales" fill="#fb8c00" name="Sprzedaż" />
            </BarChart>
          </ResponsiveContainer>
        </Box>
      )}
    </Box>
  )
}

export default OrangeOpaskaDailyChart
